import { cn } from 'lib/utils';

export type SkipLinkProps = {
  href?: string;
  className?: string;
};

const SkipLink = ({ href = '#main-content', className }: SkipLinkProps) => (
  <a
    href={href}
    className={cn(
      'sr-only focus-visible:not-sr-only focus-visible:fixed focus-visible:top-4 focus-visible:left-4 focus-visible:z-[1000] focus-visible:block focus-visible:px-4 focus-visible:py-2 focus-visible:bg-white focus-visible:text-black focus-visible:rounded-md focus-visible:font-medium focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-athletic-500 focus-visible:shadow-lg',
      className
    )}
  >
    Skip to main content
  </a>
);

export default SkipLink;
